<div class="nav-drawer" *ngIf="isOpen" @effect>
  <div><ng-content></ng-content></div>
</div>
